
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-online-class",
      function () {
        return require("private-next-pages/upsc-online-class/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-online-class"])
      });
    }
  